import React from "react";
import {
  StyledFooterWrapper,
  StyledFooterGrid,
  LinkText,
  SocialIconsContainer,
  ContactInfo,
  OtherLinks,
} from "./styled";
import { Grid, Typography, Link, SvgIcon } from "@mui/material";
import {
  Facebook,
  LinkedIn,
  Twitter,
  WhatsApp,
  Phone,
} from "@mui/icons-material";
import { colors } from "../../../theme/colors";
import { useNavigate } from "react-router-dom";

import { ReactComponent as XLogo } from "../../../img/svg/bi-icons-x.svg";
import { ReactComponent as linkedinLogo } from "../../../img/svg/linkedin-in.svg";
import { ReactComponent as PhoneIcon } from "../../../img/svg/bi-icons-telefono.svg";
import { ReactComponent as YoutubeLogo } from "../../../img/svg/bi-icons-youtube.svg";
import { ReactComponent as TiktokLogo } from "../../../img/svg/bi-icons-tiktok.svg";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <StyledFooterWrapper>
      <StyledFooterGrid container spacing={4}>
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            padding: { xs: "0px 2rem !important", md: "32px 0px !important" },
            textAlign: { xs: "left", md: "center" },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: colors.white.main,
              fontWeight: 600,
              marginBottom: "2rem",
              fontSize: "1.5rem",
            }}
          >
            Retos Bi en Línea
          </Typography>
          <LinkText component="button" onClick={() => navigate("/login")}>
            Iniciar sesión
          </LinkText>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          sx={{
            padding: { xs: "0px 2rem !important", md: "32px 0px !important" },
            textAlign: { xs: "left", md: "left" },
          }}
        >
          <LinkText
            sx={{
              fontWeight: 600,
              fontSize: "1rem !important",
              color: `${colors.white.main} !important`,
              marginBottom: "2rem",
              textAlign: { xs: "center", md: "center" },
            }}
            component="button"
            onClick={() => {}}
          >
            Blog
          </LinkText>
          <OtherLinks
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {/* <LinkText component="button" onClick={() => {}}>
              Retos del mes
            </LinkText>
            <LinkText component="button" onClick={() => {}}>
              Premios
            </LinkText> */}
            <LinkText
              component="button"
              onClick={() => {
                window.open(
                  "https://www.corporacionbi.com/gt/bancoindustrial/productos-bi/educacion-financiera-para-jovenes-entendiendo-credito-bi/",
                  "_blank"
                );
              }}
            >
              Educación Financiera
            </LinkText>
          </OtherLinks>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          sx={{
            padding: { xs: "0px 2rem !important", md: "32px 0px !important" },
            textAlign: { xs: "left", md: "left" },
          }}
        >
          <LinkText
            sx={{
              fontWeight: 600,
              fontSize: "1rem !important",
              color: `${colors.white.main} !important`,
              marginBottom: "2rem",
            }}
            component="button"
            onClick={() => {
              window.open(
                "https://www.corporacionbi.com/gt/bancoindustrial/productos-bi/retos-bi#comofunciona",
                "_blank"
              );
            }}
          >
            ¿Cómo funciona?
          </LinkText>
          <OtherLinks
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <LinkText
              component="button"
              onClick={() => {
                window.open(
                  "https://www.corporacionbi.com/gt/bancoindustrial/productos-bi/retos-bi#comocanjeomispremios",
                  "_blank"
                );
              }}
              sx={{ textAlign: { xs: "left" } }}
            >
              ¿Cómo canjeo mis premios?
            </LinkText>
            <LinkText
              component="button"
              onClick={() => {
                window.open(
                  "https://www.corporacionbi.com/gt/bancoindustrial/productos-bi/retos-bi#cualessonlasrecompensas",
                  "_blank"
                );
              }}
              sx={{ textAlign: { xs: "left" } }}
            >
              ¿Cómo funcionan las metas?
            </LinkText>
            <LinkText
              component="button"
              onClick={() => {
                window.open(
                  "https://www.corporacionbi.com/gt/bancoindustrial/productos-bi/retos-bi#preguntasfrecuentes",
                  "_blank"
                );
              }}
              sx={{ textAlign: { xs: "left" } }}
            >
              Preguntas Frecuentes (FAQ)
            </LinkText>
          </OtherLinks>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            padding: { xs: "1.5rem 0px !important", md: "0px 0px !important" },
            textAlign: { xs: "left", md: "center" },
          }}
        >
          <SocialIconsContainer>
            <Facebook
              sx={{
                fontSize: "2.5rem",
                cursor: "pointer",
                "&:hover": { opacity: 0.8 },
              }}
              onClick={() => {
                window.open(
                  "https://www.facebook.com/share/19aGpoesYb/?mibextid=wwXIfr",
                  "_blank"
                );
              }}
            />
            <SvgIcon
              component={linkedinLogo}
              inheritViewBox
              sx={{
                cursor: "pointer",
                fontSize: "2rem",
                "& path": {
                  fill: colors.secondary,
                },
              }}
              onClick={() => {
                window.open(
                  "https://www.linkedin.com/company/bancoindustrial/",
                  "_blank"
                );
              }}
            />
            <SvgIcon
              component={XLogo}
              inheritViewBox
              sx={{
                cursor: "pointer",
                fontSize: "2rem",
                "& path": {
                  fill: colors.secondary,
                },
              }}
              onClick={() => {
                window.open("https://x.com/bancoindustrial?s=11", "_blank");
              }}
            />
            <SvgIcon
              component={YoutubeLogo}
              inheritViewBox
              sx={{
                cursor: "pointer",
                fontSize: "2rem",
                "& path": {
                  fill: colors.secondary,
                },
              }}
              onClick={() => {
                window.open(
                  "https://youtube.com/@corporacionbi?si=hINv214yGfKc6HQL",
                  "_blank"
                );
              }}
            />
            <SvgIcon
              component={TiktokLogo}
              inheritViewBox
              sx={{
                cursor: "pointer",
                fontSize: "2rem",
                "& path": {
                  fill: colors.secondary,
                },
              }}
              onClick={() => {
                window.open(
                  "https://www.tiktok.com/@bancoindustrial?_t=ZM-8ygMbCcigNB&_r=1",
                  "_blank"
                );
              }}
            />
          </SocialIconsContainer>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            padding: { xs: "1rem 0rem !important", md: "32px 0px !important" },
            textAlign: { xs: "left", md: "center" },
          }}
        >
          <ContactInfo>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginBottom: "1rem",
                justifyContent: "center",
              }}
            >
              <WhatsApp
                sx={{
                  fontSize: { xs: "1.5rem", md: "1.5rem" },
                  color: colors.white.main,
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "1.5rem", md: "1.5rem" },
                  color: colors.white.main,
                }}
                onClick={() => {
                  window.location.href = "https://wa.me/1717";
                }}
              >
                1717
              </Typography>
              <SvgIcon
                component={PhoneIcon}
                inheritViewBox
                sx={{
                  cursor: "pointer",
                  fontSize: { xs: "1.5rem", md: "1.5rem" },
                  "& path": {
                    fill: colors.white.main,
                  },
                }}
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/company/bancoindustrial/",
                    "_blank"
                  );
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  cursor: "pointer",
                  fontSize: { xs: "1.5rem", md: "1.5rem" },
                  color: colors.white.main,
                }}
                onClick={() => {
                  window.open("tel:+50224116000", "_self");
                }}
              >
                2411-6000
              </Typography>
            </div>
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.9rem",
                color: colors.white.main,
                paddingTop: 2,
              }}
            >
              {new Date().getFullYear()} © Todos los derechos reservados Banco
              Industrial
            </Typography>
          </ContactInfo>
        </Grid>
      </StyledFooterGrid>
    </StyledFooterWrapper>
  );
}
